import { IonApp, IonContent, IonPage, IonSpinner } from "@ionic/react";
import Cross from "assets/images/icon/svg/Cross";
import BackButtonTitle from "components/mobile-components/Common/BackButtonTitle";
import ProfitLossBottomSheet from "components/mobile-components/ProfitLoss/ProfitLossBottomSheet";
import { getUserBusiness } from "config/user";
import { COUNTRYINFO } from "data/country";
import { dateTimeFormatter, numberWithCommas } from "helpers/helper";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Bar, getElementAtEvent } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setSelectedTab } from "redux/container/accountSlice";
import { getSelectedDate, setAccountingCategory, setIsCategory, setIsFilter, setSelectedDate } from "redux/container/dashboardSlice";
import Accounts from "services/Accounts";

const TotalProfitLossPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const barRef = useRef();
  const location = useLocation();
  let getBusiness = getUserBusiness();
  const ekkLanguage = useSelector((state) => state.lan.lan);
  const date = useSelector((state) => state.dashboard.dateInfo);
  const createUserData = useSelector((state) => state.user.createUserData);
  const dateFormat = useSelector((state) => state.date.format);
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const searchParams = new URLSearchParams(location?.search);
  const [getDate, setGetDate] = useState({
    start: moment().startOf("month").format("YYYY-MM-DD"),
    end: moment().endOf("month").format("YYYY-MM-DD"),
  });

  const profitLossBarRef = useRef();
  const [profitLossData, setProfitLossData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currency, setCurrency] = useState("$");
  let [revenueData, setRevenueData] = useState([]);
  let [expenseData, setExpenseData] = useState(null);
  let [taxData, setTaxData] = useState(null);
  let [depreciationData, setDepreciationData] = useState(null);
  let [netProfitData, setNetProfitData] = useState(null);
  let [interestData, setInterestData] = useState(null);
  const [filterClicked, setFilterClicked] = useState(false);

  let value = date?.level;

  const chartOptions = {
    barPercentage: 0.6,
    plugins: {
      legend: false,
    },
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
      const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
      const dateTime = { start: startOfMonth, end: endOfMonth, level: "month" };

      dispatch(getSelectedDate(dateTime));
      setGetDate({ start: startOfMonth, end: endOfMonth });

      fetchProfitLossChartData(startOfMonth, endOfMonth);
    }, 700);

    return () => clearTimeout(timeout);
  }, []);
  useEffect(() => {
    if (getDate?.start && getDate?.end) {
      getRevenueData();
      getExpenseData();
      getTaxData();
      getDepreciationData();
      getInterestData();
      getNetProfitData();
    }
  }, [getDate?.start, getDate?.end]);

  const fetchProfitLossChartData = async (start, end) => {
    setLoading(true);
    let response = await Accounts.getDashboardTransactions(timeZone);
    if (response.success) {
      setProfitLossData(
        response?.data.map(
          (elements) =>
            elements && {
              ...elements,
              name: elements.month,
              value: elements?.net_profit,
            }
        )
      );
      setCurrency(response?.currency);
    }
    setLoading(false);
  };

  const getRevenueData = async () => {
    setLoading(true);
    let response = await Accounts.getProfitLossDateWays(
      getDate?.start,
      getDate?.end,
      timeZone
    );

    if (response.status === 200) {
      setLoading(false);
      setRevenueData(response.results);
    } else {
      setLoading(false);
      setRevenueData([]);
    }
  };
  const getExpenseData = async () => {
    setLoading(true);
    let response = await Accounts.getExpenseDateWays(
      getDate?.start,
      getDate?.end,
      timeZone
    );

    if (response.status === 200) {
      setLoading(false);
      setExpenseData(response.results);
    } else {
      setLoading(false);
      setExpenseData(null);
    }
  };
  const getTaxData = async () => {
    setLoading(true);
    let response = await Accounts.getTaxDateWays(
      getDate?.start,
      getDate?.end,
      timeZone
    );
    if (response.status === 200) {
      setLoading(false);
      setTaxData(response.results);
    } else {
      setLoading(false);
      setTaxData(null);
    }
  };



  const getDepreciationData = async () => {
    setLoading(true);
    let response = await Accounts.getDepreciationDateWays(
      getDate?.start,
      getDate?.end,
      timeZone
    );
    if (response.status === 200) {
      setLoading(false);
      setDepreciationData(response.results);
    } else {
      setLoading(false);
      setDepreciationData(null);
    }
  };
  const getInterestData = async () => {
    setLoading(true);
    let response = await Accounts.getInterestDateWays(
      getDate?.start,
      getDate?.end,
      timeZone
    );
    if (response.status === 200) {
      setLoading(false);
      setInterestData(response.results);
    } else {
      setLoading(false);
      setInterestData(null);
    }
  };

  const getNetProfitData = async () => {
    setLoading(true);
    let response = await Accounts.getNetProfitDateWays(
      getDate?.start,
      getDate?.end,
      timeZone
    );
    if (response.status === 200) {
      setLoading(false);
      setNetProfitData(response.results);
    } else {
      setLoading(false);
      setNetProfitData(null);
    }
  };
  const chartData = {
    labels: profitLossData?.map((item) =>
      moment(item?.month, "MM-YYYY").format("MMM/YY")
    ),
    datasets: [
      {
        label: "Profit and Loss",
        data: profitLossData?.map((entry) => entry?.value),
        backgroundColor: profitLossData?.map((entry) =>
          entry.value >= 0 ? "#00B224" : "#FB766E"
        ),
        tooltipLabel: profitLossData?.map((entry) =>
          entry.value >= 0 ? "Revenue" : "Expense"
        ), // Custom label for each bar in the tooltip
      },
    ],
  };
  const barClickHandler = async (event) => {
    const config = {
      ref: profitLossBarRef,
      data: chartData,
    };

    const elementIndex = getElementAtEvent(config.ref.current, event)[0]?.index;
    if (elementIndex === undefined) return;

    const date = config.data?.labels[elementIndex];
    const value = config.data?.datasets[0].data[elementIndex];
    if (value === 0) return;

    const startTime = moment(date, "MMM/YY")
      .startOf("month")
      .format("YYYY-MM-DD");
    const endTime = moment(date, "MMM/YY").endOf("month").format("YYYY-MM-DD");

    const dateTime = {
      start: startTime,
      end: endTime,
      level: "month",
    };

    dispatch(getSelectedDate(dateTime));
    setGetDate(dateTime);
  };
  const handleCrossFilter = () => {
    let date = {
      value: "month",
      label: ekkLanguage.dashboard.thisMonth,
      name: "This Month",
    };
    let timeDate = dateTimeFormatter(date?.value);
    let dateTime = { ...timeDate, level: date?.name };
    setGetDate({
      start: moment(timeDate?.start).format("YYYY-MM-DD"),
      end: moment(timeDate?.end).format("YYYY-MM-DD"),
    });
    dispatch(getSelectedDate(dateTime));
    setFilterClicked(false);
  };

  return (
    <IonApp>
      <IonPage>
        <IonContent>
          <BackButtonTitle
            title="Profit and Loss"
            filter={true}
            setGetDate={setGetDate}
            from="profitLoss"
            setFilterClicked={setFilterClicked}
            filterClicked={filterClicked}
          />
          <div className="pt-14 px-4">
            {!filterClicked && (
              <div className="chart-wrapper relative mb-4">
                {loading && (
                  <div className="absolute h-full w-full flex justify-center items-center left-[7%] top-[5%]">
                    <IonSpinner name="circular" />
                  </div>
                )}
                <div className="px-2 pb-1 flex justify-between items-center pt-5">
                  <h4 className="font-bold text-18 sm:text-20 text-black-1000 mb-2">
                    Total Profit / Loss
                  </h4>
                </div>
                <div
                  className="flex justify-center px-2"
                  style={{ width: "100%", maxWidth: "768px" }}
                >
                  <Bar
                    data={chartData}
                    options={chartOptions}
                    ref={profitLossBarRef}
                    onClick={barClickHandler}
                  />
                </div>
              </div>
            )}

            <div className={`${!filterClicked ? "mt-14" : "mt-4"} px-4`}>
              <div className="pb-10">
                <div className="pt-3">
                  <div className="pb-5">
                    <h2 className="text-lg font-bold mb-6 text-center">
                      Profit and Loss Statement
                      <p className="text-sm font-semibold">
                        {getBusiness?.business_name}
                      </p>
                      <p className="text-sm font-semibold">
                        {getBusiness?.address_line}
                      </p>
                      <div className="flex justify-center items-center w-full">
                        <p className="text-sm font-semibold">
                          <span>
                            {moment(getDate?.start, '"YYYY-MM-DD"').format(
                              dateFormat
                            )}{" "}
                            -{" "}
                            {moment(getDate?.end, "YYYY-MM-DD").format(
                              dateFormat
                            )}
                          </span>
                        </p>
                        {filterClicked && (
                          <div
                            onClick={handleCrossFilter}
                            className="ml-1 p-1 bg-white border rounded-full shadow-xl cursor-pointer"
                          >
                            <Cross color={"black"} />
                          </div>
                        )}
                      </div>
                    </h2>
                    <table className="table-auto w-full bg-white shadow-md">
                      <thead>
                        <tr className="border h-[45px] border-gray-300">
                          <th className="border p-2 font-bold text-left">
                            Revenue
                          </th>
                          <th className="border p-2 font-bold text-right">
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody style={{ borderBottom: "1.5px solid #888" }}>
                        {revenueData?.revenue?.length
                          ? revenueData?.revenue?.map((item, index) => (
                              <tr key={index} className="border" onClick={() => {
                                navigate(`/accounts/?from=profitLoss`)
                                dispatch(setAccountingCategory(Object.values(item)[0].category));
										            dispatch(setIsCategory(true));
                              
                                let dateTime = {
                                  start: getDate?.start,
                                  end: getDate?.end,
                                  level: "today",
                                };
                                dispatch(setSelectedDate(dateTime));
                                dispatch(setIsFilter(true));
                                dispatch(setSelectedTab('Revenue'));
                              }}>
                                <td className="border p-2 pl-6 text-delivered">
                                  {Object.keys(item)[0]}
                                </td>
                                <td className="border p-2 text-right">
                                  {currency}
                                  {numberWithCommas(Object.values(item)[0].amount)}
                                </td>
                              </tr>
                            ))
                          : undefined}
                      </tbody>
                      <tfoot>
                        <tr className="border font-bold border-t-1 border-t-black">
                          <td className="border p-2 ">Total Revenue</td>
                          <td className="border p-2 text-right ">
                            {currency}
                            {numberWithCommas(revenueData?.total_revenue)}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div className="pb-5">
                    <table className="table-auto w-full bg-white shadow-md">
                      <thead>
                        <tr className="border h-[45px] border-gray-300">
                          <th className="border p-2 font-bold text-left">
                            Cost of Goods Sold(COGS)
                          </th>
                          <th className="border p-2 font-bold text-right">
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody style={{ borderBottom: "1.5px solid #888" }}>
                        {Object.entries(revenueData?.cost_of_goods_sold || {})
                          .filter(([key]) => key !== "Total Cost")
                          .map(([key, value], index) => (
                            <tr key={index} className="border  cursor-pointer" onClick={() => {
                              navigate(`/accounts/?from=profitLoss`)
                              dispatch(setAccountingCategory(value));
                              dispatch(setIsCategory(true));
                            
                              let dateTime = {
                                start: getDate?.start,
                                end: getDate?.end,
                                level: "today",
                              };
                              dispatch(setSelectedDate(dateTime));
                              dispatch(setIsFilter(true));
                              dispatch(setSelectedTab('Expense'));
                            }}>
                              <td className="border p-2 pl-6 text-delivered">{key}</td>
                              <td className="border p-2 text-right">
                                {currency}
                                {numberWithCommas(value?.amount)}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                      <tfoot>
                        <tr className="border font-bold border-t-1 border-t-black">
                          <td className="border p-2 ">
                            Total Cost of Goods Sold(COGS)
                          </td>
                          <td className="border p-2 text-right ">
                            {currency}
                            {numberWithCommas(
                              revenueData?.cost_of_goods_sold?.["Total Cost"]
                            )}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div className="pb-5">
                    <div className="flex justify-between items-center">
                      <h2 className="text-lg font-bold mb-2">Gross Profit</h2>
                      <h2 className="text-lg font-bold mb-2">
                        {currency}
                        {numberWithCommas(netProfitData?.gross_profit)}
                      </h2>
                    </div>
                  </div>

                  <div className="pb-5">
                    <table className="table-auto w-full bg-white shadow-md">
                      <thead>
                        <tr className="border h-[45px] border-gray-300">
                          <th className="border p-2 font-bold text-left">
                            Operating Expense
                          </th>
                          <th className="border p-2 font-bold text-right">
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody style={{ borderBottom: "1.5px solid #888" }}>
                        {expenseData?.["Operating Expense"] &&
                          Object.entries(
                            expenseData?.["Operating Expense"]
                          ).map(([key, value], index) => {
                            if (
                              key === "total_operating_expense" ||
                              key === "currency"
                            )
                              return null;

                            return (
                              <React.Fragment key={index}>
                                <tr className="border ">
                                  <td className="border p-2 font-bold pl-6">
                                    {key}
                                  </td>
                                  <td className="border p-2"></td>
                                </tr>

                                {Array.isArray(value.category || value) &&
                                  (value.category || value).map(
                                    (item, subIndex) => (
                                      <tr key={subIndex} className="border cursor-pointer" onClick={() => {
                                        navigate(`/accounts/?from=profitLoss`)
                                        dispatch(setAccountingCategory(item.category));
                                        dispatch(setIsCategory(true));
                                      
                                        let dateTime = {
                                          start: getDate?.start,
                                          end: getDate?.end,
                                          level: "today",
                                        };
                                        dispatch(setSelectedDate(dateTime));
                                        dispatch(setIsFilter(true));
                                        dispatch(setSelectedTab('Expense'));
                                      }}>
                                        <td className="border p-2 pl-6 text-delivered">
                                          {item.category?.title}
                                        </td>
                                        <td className="border p-2 text-right">
                                          {currency}
                                          {numberWithCommas(item.amount)}
                                        </td>
                                      </tr>
                                    )
                                  )}

                                <tr className="border font-bold ">
                                  <td
                                    className="border p-2 pl-6"
                                    style={{
                                      borderTop: "1.5px solid #888",
                                    }}
                                  >
                                    Total {key}
                                  </td>
                                  <td
                                    className="border p-2 text-right"
                                    style={{
                                      borderTop: "1.5px solid #888",
                                    }}
                                  >
                                    {currency}
                                    {numberWithCommas(value.total_amount)}
                                  </td>
                                </tr>

                                <tr>
                                  <td className="p-2"></td>
                                  <td className="p-2"></td>
                                </tr>
                              </React.Fragment>
                            );
                          })}
                      </tbody>
                      <tfoot>
                        <tr className="border font-bold border-t-1 border-t-black">
                          <td className="border p-2">
                            Total Operating Expense
                          </td>
                          <td className="border p-2 text-right">
                            {currency}
                            {numberWithCommas(
                              expenseData?.["Operating Expense"]
                                ?.total_operating_expense
                            )}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                  <div className="pb-5">
                    <div className="flex justify-between items-center">
                      <h2 className="text-lg font-bold mb-2">
                        Operating Profit (EBITDA)
                      </h2>
                      <h2 className="text-lg font-bold mb-2">
                        {currency}
                        {numberWithCommas(netProfitData?.operating_profit)}
                      </h2>
                    </div>
                  </div>

                  <div className="pb-5">
                    <table className="table-auto w-full bg-white shadow-md">
                      <thead>
                        <tr className="border h-[45px] border-gray-300">
                          <th className="border p-2 font-bold text-left">
                            Interest
                          </th>
                          <th className="border p-2 font-bold text-right">
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody style={{ borderBottom: "1.5px solid #888" }}>
                        {interestData?.["Interest Expense"] &&
                          Object.entries(
                            interestData?.["Interest Expense"]
                          ).map(([key, value], index) => {
                            if (key === "total_expense" || key === "currency")
                              return null;

                            return (
                              <React.Fragment key={index}>
                                {Array.isArray(value.category || value) &&
                                  (value.category || value).map(
                                    (item, subIndex) => (
                                      <tr key={subIndex} className="border" onClick={() => {
                                        navigate(`/accounts/?from=profitLoss`)
                                        dispatch(setAccountingCategory(item.category));
                                        dispatch(setIsCategory(true));
                                      
                                        let dateTime = {
                                          start: getDate?.start,
                                          end: getDate?.end,
                                          level: "today",
                                        };
                                        dispatch(setSelectedDate(dateTime));
                                        dispatch(setIsFilter(true));
                                        dispatch(setSelectedTab('Expense'));
                                      }}>
                                        <td className="border p-2 pl-6 text-delivered">
                                          {item.category?.title}
                                        </td>
                                        <td className="border p-2 text-right">
                                          {currency}
                                          {numberWithCommas(item.amount)}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                <tr>
                                  <td className="p-2"></td>
                                  <td className="p-2"></td>
                                </tr>
                              </React.Fragment>
                            );
                          })}
                      </tbody>
                      <tfoot>
                        <tr className="border font-bold border-t-1 border-t-black">
                          <td className="border p-2">
                            Total Interest
                          </td>
                          <td className="border p-2 text-right">
                            {currency}
                            {numberWithCommas(
                              interestData?.[
                                "Interest Expense"
                              ]?.total_interest_expense
                            )}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                  {taxData?.["Tax"] &&
                    Object.entries(taxData?.["Tax"]).some(
                      ([key, value]) =>
                        key !== "total_tax" && 
                        Array.isArray(value.category) &&
                        value.category.length > 0
                    ) && (
                      <div className="pb-5">
                        <table className="table-auto w-full bg-white shadow-md">
                          <thead>
                            <tr className="border h-[45px] border-gray-300">
                              <th className="border p-2 font-bold text-left">
                                Tax
                              </th>
                              <th className="border p-2 font-bold text-right">
                                Amount
                              </th>
                            </tr>
                          </thead>
                          <tbody
                            style={{
                              borderBottom: "1.5px solid #888",
                            }}
                          >
                            {Object.entries(taxData?.["Tax"]).reverse().map(
                              ([key, value], index) => {
                                if (
                                  key === "total_tax" ||
                                  !value.category ||
                                  value.category.length === 0
                                )
                                  return null;

                                return (
                                  <React.Fragment key={index}>
                                    <tr className="border ">
                                      <td className="border p-2 font-bold pl-6">
                                        {key}
                                      </td>
                                      <td className="border p-2"></td>
                                    </tr>

                                    {Array.isArray(value.category) &&
                                      value.category.map((item, subIndex) => (
                                        <React.Fragment key={subIndex}>
                                          <tr className="border cursor-pointer" onClick={() => {
                                            if(key === "Revenue Tax"){
                                              navigate(`/tax-summary-category-wise?category_id=${item.category?.id}&start=${getDate?.start}&end=${getDate?.end}&from=profitLoss&title=${item.category?.title}`);
                                            }else{
                                                dispatch(setAccountingCategory(item.category));
                                                dispatch(setIsCategory(true));
                                                let dateTime = {
                                                  start: getDate?.start,
                                                  end: getDate?.end,
                                                  level: "today",
                                                };
                                                dispatch(setSelectedDate(dateTime));
                                                dispatch(setIsFilter(true));
                                                dispatch(setSelectedTab('Expense'));
                                                navigate(`/accounts/?from=profitLoss`)
                                            }
                                          }}>
                                            <td className="p-2 pl-6 flex items-center text-delivered">
                                              {item.category?.title}
                                            </td>
                                            <td className="border p-2 text-right">
                                              {currency}
                                              {numberWithCommas(item.amount)}
                                            </td>
                                          </tr>
                                          
                                        </React.Fragment>
                                      ))}

                                    {value.category && (
                                      <tr className="border font-bold ">
                                        <td
                                          className="border p-2 pl-6"
                                          style={{
                                            borderTop: "1.5px solid #888",
                                          }}
                                        >
                                          Total {key}
                                        </td>
                                        <td
                                          className="border p-2 text-right"
                                          style={{
                                            borderTop: "1.5px solid #888",
                                          }}
                                        >
                                          {currency}
                                          {numberWithCommas(value.total_amount)}
                                        </td>
                                      </tr>
                                    )}

                                    <tr>
                                      <td className="p-2"></td>
                                      <td className="p-2"></td>
                                    </tr>
                                  </React.Fragment>
                                );
                              }
                            )}
                          </tbody>
                          <tfoot>
                            <tr className="border font-bold border-t-1 border-t-black">
                              <td className="border p-2">Total Tax</td>
                              <td className="border p-2 text-right">
                                {currency}
                                {numberWithCommas(taxData?.["Tax"]?.total_tax)}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    )}

                  <div className="pb-5">
                    <table className="table-auto w-full bg-white shadow-md">
                      <thead>
                        <tr className="border h-[45px] border-gray-300">
                          <th className="border p-2 font-bold text-left">
                            Amortization and Depreciation
                          </th>
                          <th className="border p-2 font-bold text-right">
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody style={{ borderBottom: "1.5px solid #888" }}>
                        {depreciationData?.["Amortization and Depreciation"] &&
                          Object.entries(
                            depreciationData?.["Amortization and Depreciation"]
                          ).map(([key, value], index) => {
                            if (key === "total_expense" || key === "currency")
                              return null;

                            return (
                              <React.Fragment key={index}>
                                {Array.isArray(value.category || value) &&
                                  (value.category || value).map(
                                    (item, subIndex) => (
                                      <tr key={subIndex} className="border" onClick={() => {
                                        navigate(`/accounts/?from=profitLoss`)
                                        dispatch(setAccountingCategory(item.category));
                                        dispatch(setIsCategory(true));
                                      
                                        let dateTime = {
                                          start: getDate?.start,
                                          end: getDate?.end,
                                          level: "today",
                                        };
                                        dispatch(setSelectedDate(dateTime));
                                        dispatch(setIsFilter(true));
                                        dispatch(setSelectedTab('Expense'));
                                      }}>
                                        <td className="border p-2 pl-6 text-delivered">
                                          {item.category?.title}
                                        </td>
                                        <td className="border p-2 text-right">
                                          {currency}
                                          {numberWithCommas(item.amount)}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                <tr>
                                  <td className="p-2"></td>
                                  <td className="p-2"></td>
                                </tr>
                              </React.Fragment>
                            );
                          })}
                      </tbody>
                      <tfoot>
                        <tr className="border font-bold border-t-1 border-t-black">
                          <td className="border p-2">
                            Total Amortization and Depreciation
                          </td>
                          <td className="border p-2 text-right">
                            {currency}
                            {numberWithCommas(
                              depreciationData?.[
                                "Amortization and Depreciation"
                              ]?.total_expense
                            )}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                  <div className="pb-5">
                    <div className="flex justify-between items-center">
                      <h2 className="text-lg font-bold mb-2">Net Profit</h2>
                      <h2 className="text-lg font-bold mb-2">
                        {currency}
                        {numberWithCommas(netProfitData?.net_profit)}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </IonContent>
      </IonPage>
      <ProfitLossBottomSheet getDate={getDate} />
    </IonApp>
  );
};

export default TotalProfitLossPage;
